import React from 'react';
import { Box, Heading, Text, VStack } from '@chakra-ui/react';

const JoinUsHero = () => {
  return (
    <Box
      w="100%"
      minH={{ base: '200px', sm: '220px', md: '240px', lg: '260px' }}
      bg="#25575F"
      bgImage="url('/png/career-header.png')"
      bgSize="contain"
      bgPosition="contain"
      bgRepeat="no-repeat"
      display="flex"
      alignItems="center"
      justifyContent="center"
      position="relative"
      px={{ base: 2, sm: 4, md: 0 }}
      _after={{
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        w: '100%',
        h: '100%',
        bg: 'rgba(24, 41, 32, 0.0)',
        zIndex: 1,
      }}
    >
      <VStack
        spacing={{ base: 2, md: 3 }}
        zIndex={2}
        position="relative"
        textAlign="center"
        w="full"
        px={{ base: 1, sm: 4, md: 0 }}
      >
        <Heading
          as="h1"
          fontSize={{ base: '3xl', md: '5xl' }}
          color="#E6FF3F"
          fontWeight="bold"
          lineHeight="1.1"
        >
          Join Us
        </Heading>
        <Text color="white" fontSize={{ base: 'md', sm: 'lg', md: '2xl' }}>
          Let's join with us
        </Text>
      </VStack>
    </Box>
  );
};

export default JoinUsHero; 